import { createRootRoute, HeadContent, Outlet } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import { site } from "@/config.ts";

export const Route = createRootRoute({
  component: () => (
    <>
      <HeadContent />
      <Outlet />
      <TanStackRouterDevtools />
    </>
  ),
  head: () => ({
    links: site.favicons.map((favicon) => ({
      rel: "icon",
      href: `/assets/favicons/${favicon}`,
    })),
  }),
});
